import RoofSnapApiClient from "./roofSnapApiClient";

const baseUrl = 'organizations';

class OrganizationClient extends RoofSnapApiClient {
    async getOrganizations(params) {
        const { queryParams } = params;
        try {
            const url = `${baseUrl}${queryParams}`;
            return await super.get(url);
        } catch (error) {
            return Promise.reject(error);
        }
    }
}

export default OrganizationClient;
